
// Selectable Table: Select record by checkbox handle
//      table must has .table-selectable class
//      add data-toggle="select" to th for select all function
//      add data-toggle="select" to td for select individual record


export default class SelectableTable {
    private table: HTMLTableElement;
    private selectAllElement: HTMLElement;

    constructor(table: HTMLTableElement) {
        this.table = table;
        this.selectAllElement = table.querySelector('thead [data-toggle="select"]');
    }

    init = () => {
        // event: select all
        this.selectAllElement?.addEventListener("click", this._selectAllHandler);
        // event: select individual
        this.table.querySelectorAll('tbody [data-toggle="select"]').forEach(element => {
            element.addEventListener("click", this._selectSingleHandler);
        });
    }

    private _selectAllHandler = (e: MouseEvent) => {
        e.preventDefault();
        // get all rows
        const allRows: HTMLElement[] = [].slice.call(this.table.querySelectorAll<HTMLElement>("tbody tr"));
        const isCheckedAll = allRows.find(row => !this._isRowSelected(row)) === undefined;
        const newCheckState = !isCheckedAll;
        // uncheck all of already selected all

        this.table.querySelectorAll<HTMLElement>("tbody tr").forEach(row => {
            this._toggleRow(row, newCheckState);
        });
    }
    private _selectSingleHandler = (e: MouseEvent) => {
        e.preventDefault();
        const row = (e.target as HTMLElement).closest("tr");
        // toggle
        this._toggleRow(row);
    }
    private _toggleRow = (row: HTMLElement, checked?: boolean) => {
        // get elements
        const selectElement = row.querySelector('[data-toggle="select"]');
        const checkboxElement = selectElement.querySelector<HTMLInputElement>('input[type="checkbox"], input[type="radio"]');
        const currentState = checkboxElement.checked;

        // check
        if (checked !== undefined) {
            checkboxElement.checked = checked;
        }
        // toggle
        else {
            checkboxElement.checked = !currentState;
        }
    }
    private _isRowSelected = (row: HTMLElement) => {
        // get elements
        const selectElement = row.querySelector('[data-toggle="select"]');
        const checkboxElement = selectElement.querySelector<HTMLInputElement>('input[type="checkbox"], input[type="radio"]');
        return checkboxElement.checked;
    }
}